import React, {useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import {Container, Header, Item, ItemExtra, Rating, Segment} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {reviewApi} from '../misc/ReviewApi'
import {getStatus, handleLogError} from '../misc/Helpers'
import MyMessages from "./MyMessages";
import {useParams} from "react-router";
import TripList from "./TripList";
import Reviews from "./Reviews";

function ReviewsPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'

  let reviewsList

  const {userId} = useParams()

  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    handleGetUserReviews()
  }, [])


  const handleGetUserReviews = async () => {
    try {
      setLoading(true)
      const reviews = await reviewApi.getUserReviews(user, userId)
      setReviews(reviews.data)
      console.log(reviews.data)
      if(reviews.data.length > 0) {
        reviewsList = reviews.data.map(review => {
          return (
            <Item key={review.id}>
              <Item.Content>
                <Item.Header>Отзыв о {review.target.name} с поездки {review.trip.fromCity} - {review.trip.toCity}
                </Item.Header>
                <Item.Meta>{new Date(review.trip.tripTime).toLocaleString('ru',
                  {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false
                  })}</Item.Meta>
                <Item.Description>
                  {review.notes}
                </Item.Description>
                <ItemExtra>
                  <Rating icon="star" defaultRating={review.mark} maxRating={5} disabled />
                </ItemExtra>
              </Item.Content>
            </Item>
          )
        })
      }
      console.log(reviewsList)
    } catch (error) {
      handleLogError(error)
    } finally {
      setLoading(false)
    }
  }

  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <Reviews
        loading={loading}
        reviews={reviews}
      />
    </Container>
  )
}

export default ReviewsPage
